// These actions are for tournament management only.
export function useTournamentActions() {
  const actionsLoading = ref(false)
  const errors = ref<{ [key: string]: string[] } | null>(null)

  const { $api } = useNuxtApp()

  function clearFormErrors() {
    errors.value = {}
  }

  function getError(key: string): string | undefined {
    if (errors.value && errors.value[key] && errors.value[key][0]) {
      return errors.value[key][0]
    }
    return undefined
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function callAction(tournament_id: number, action: string, data: object = {}): Promise<any> {
    clearFormErrors()
    actionsLoading.value = true

    return $api('/play/{tournament}/action', {
      path: {
        tournament: tournament_id,
      },
      method: 'POST',
      body: {
        action: action,
        ...data,
      },
    })
      .then((data) => {
        return data
      })
      .catch((e) => {
        if (e.data.errors) {
          errors.value = e.data.errors
        }
        throw new Error('Action failed')
      })
      .finally(() => {
        actionsLoading.value = false
      })
  }

  return { callAction, getError }
}
